import { css } from 'styled-components';

const variables = css`
  :root {
    /* Custom palette — inspired by classic dark portfolios, not a 1:1 copy */
    --dark-navy: #050a14;
    --navy: #000000;
    --light-navy: #1a2332;
    --lightest-navy: #2a3548;
    --navy-shadow: rgba(15, 23, 42, 0.75);
    --dark-slate: #526077;
    --slate: #8b9cb3;
    --light-slate: #b4c5d9;
    --lightest-slate: #dce6f2;
    --white: #f0f4f8;
    --green: #ffd580;
    --green-tint: rgba(82, 212, 196, 0.1);
    --pink: #e879a8;
    --blue: #6eb5ff;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
